module.exports = __webpack_public_path__ + "static/media/bet-logo-damacai.336ac970.png";